import { Chip, Grid } from "@mui/material";
import EditAction from "../components/edit-action/edit-action";
import DeleteAction from "../components/delete-action/delete-action";
import VerifyAccess from "@/common/components/verify-access/verify-access";
import { requestedMenuAll, requestedFeaturesAll } from "@/from-theme/routes/constants/menuAccess";
import { dateString } from "@/common/components/TableView/helpers/helpers";
const {menuAccessTabMasterKey} = requestedMenuAll;
const {updateKey, deleteKey} = requestedFeaturesAll;
export const columns = ({ onRowEdit, onRowDelete, deleteProductMasterStatus,
  isUpdateDeleteAccess }) => ([...[
  {
    header: 's-no',
    accessorKey: 'faProdCatId',
    cell: (value) => {
      const faProdCatId = value.row.index + 1;
     return faProdCatId;
    }
  },
  {
    header: 'division-name',
    accessorKey: 'divisionName'
  },
  {
    header: 'user-name',
    accessorKey: 'userName'
  },
  {
    header: 'menu-access-count',
    accessorKey: 'count'
  },
  {
    header: 'created-at',
    hideColumn: true,
    accessorKey: 'createdAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'created-by',
    hideColumn: true,
    accessorKey: 'createdBy'
  },
  {
    header: 'updated-at',
    hideColumn: true,
    accessorKey: 'updatedAt',
    cell: ({ getValue }) => dateString(getValue()) 
  },
  {
    header: 'updated-by',
    hideColumn: true,
    accessorKey: 'updatedBy'
  },
  {
    header: 'status',
    accessorKey: 'activeStatus',
    cell: (cell) => {
      switch (cell.getValue()) {
        case '0':
          return <Chip color="error" label="In-Active" size="small" variant="light" />;
        case '1':
          return <Chip color="success" label="Active" size="small" variant="light" />;

      }
    }
  }
], ...(isUpdateDeleteAccess ? [
  {
    header: 'action',
    id: "edit",
    cell: (props) => (
      <Grid container className="table-icon-actions-2">
        <VerifyAccess requestedMenu={menuAccessTabMasterKey} requestedFeature={updateKey}>
        <Grid item>
          <EditAction
            {...props}
            onRowEdit={onRowEdit}
          />
        </Grid>
        </VerifyAccess>
        <VerifyAccess requestedMenu={menuAccessTabMasterKey} requestedFeature={deleteKey}>
        <Grid item>
          <DeleteAction
            {...props}
            onRowDelete={onRowDelete} deleteProductMasterStatus={deleteProductMasterStatus}
          />
        </Grid>
        </VerifyAccess>

      </Grid>
    ),
    meta: {
      className: 'cell-center'
    }
  }

]:[])]);

export const reportFileName = "Menu Access Master";

